module.exports = __webpack_public_path__ + "img/apiDocumentationActive.47573699.svg";